/** @format */

import { Injectable, TransferState, makeStateKey } from '@angular/core';
import { map, retry } from 'rxjs/operators';

import { Environment } from '@shared/data-access/interfaces';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CeopsService {
	API_URL: string;
	constructor(
		private http: HttpClient,
		private environment: Environment,
		private readonly state: TransferState
	) {
		this.API_URL = this.environment.api.ceops;
	}
	readonly CEOPS_SCRIPS_STATE_KEY_PREFIX = 'ceops-scripts';

	public getScripts$(urlToCheck, chain, retries = 0, useCachedCeopsScripts = false) {
		const requestUrl = `${this.API_URL}/scripts?chain=${chain}&page=${urlToCheck}&all=true`;

		const STATE_KEY = makeStateKey<any>(`${this.CEOPS_SCRIPS_STATE_KEY_PREFIX}`);
		if (useCachedCeopsScripts) {
			const stateData: any = this.state.get(STATE_KEY, null);
			if (stateData) {
				return of(stateData);
			}
		}

		return this.http.get(requestUrl).pipe(
			map((response: any) => {
				if (response.scripts && response.scripts.length > 0) {
					response.scripts.forEach((script) => {
						if (script && script.path) {
							script.src = script.path.includes('//')
								? script.path
								: `${this.API_URL}/out${script.path}.min.js?_=${response.version}`;
						}
					});
				}
				if (useCachedCeopsScripts) {
					this.state.set<any>(STATE_KEY, response);
				}
				return response;
			}),
			retry(retries)
		);
	}
}
